module.exports = __webpack_public_path__ + "img/model14.282ecada.png";